module.exports = __webpack_public_path__ + "media/images/static/benefit/fig_merit3-2_e_learning-5d390c87472c8f4d238084f638ec704a.png";